import PropTypes, { number, string } from 'prop-types';

/**
 * A single checkbox input
 * 
 * @param {object} props
 * @param {string} props.id - checkbox ID
 * @param {string} props.name - name of checkbox group
 * @param {string} props.value - checkbox value and label text
 * @param {string} props.label - label associated with checkbox
 * @param {Function} props.onChange - function that runs when a checkbox is toggled
 * @param {boolean} props.disabled - true if checkbox is disabled, false otherwise
 * @param {boolean} props.checked - true if checkbox is checked, false otherwise
 */
const CheckboxInput = ({ id, name, value, label, onChange, disabled, checked, style }) => {
    return (
        <div className='checkbox-input'>
            <input
                type="checkbox"
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                checked={checked}
                style={style}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
}

CheckboxInput.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([string, number]).isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
};

export default CheckboxInput;